import type { ReactNode } from 'react'
import { forwardRef } from 'react'
import clsx from 'clsx'

import type { BoxPropsAs } from '@jotta/ui/Box'
import { Box } from '@jotta/ui/Box'

import type { HeadLineProps } from '../../Typography/Headline/Headline'
import { Headline, Headline6 } from '../../Typography/Headline/Headline'
import { useAnimateHiddenClass } from '../../utils/animation'

/**
 * @deprecated Only use together with <DeprecatedCard />
 */
export type DeprecatedCardProps = BoxPropsAs<
  'div',
  {
    secondaryTitle?: ReactNode
  } & HeadLineProps,
  'all'
>

/**
 * @deprecated Use <Card /> instead
 */
export const DeprecatedCard = forwardRef<HTMLDivElement, DeprecatedCardProps>(
  function Card(
    {
      variant = 'cards.primary',
      tag = 'h2',
      level = 2,
      title,
      secondaryTitle,
      children,
      className,
      hidden,
      ...props
    },
    ref,
  ) {
    return (
      <Box
        variant={variant}
        ref={ref}
        sx={{
          borderRadius: '12px',
        }}
        className={clsx(useAnimateHiddenClass(hidden), className)}
        {...props}
      >
        {title && (
          <hgroup>
            {!!secondaryTitle && <Headline6 pb="0">{secondaryTitle}</Headline6>}
            <Headline
              pb={2}
              sx={{
                marginBlockStart: 0,
              }}
              tag={tag}
              level={level}
            >
              {title}
            </Headline>
          </hgroup>
        )}
        {children}
      </Box>
    )
  },
)
